import { cn } from '@/lib/cn';
import { formatMoney } from '@/lib/format';

export function Money({ value, className, tone }: { value: number | null | undefined; className?: string; tone?: 'auto' | 'danger' | 'success' }) {
  const color = tone === 'danger' ? 'text-danger' : tone === 'success' ? 'text-success' : tone === 'auto' && (value ?? 0) < 0 ? 'text-success' : '';
  return <span className={cn('ltr-nums font-semibold', color, className)}>{formatMoney(value)}</span>;
}
